export default {

    transformNumeric(item, key) {
        return item ? (typeof item[key] !== 'undefined' ? (typeof item[key] !== 'number' ? parseInt(item[key]) : item[key]) : 0) : 0
    },

    transformString(item, key) {
        return item ? (typeof item[key] !== 'undefined' ? (typeof item[key] !== 'string' ? String(item[key]) : item[key]) : '') : '';
    },

    transformDateFromTimestamp(item, key) {
        return item ? (typeof item[key] !== 'undefined' ? (typeof item[key] !== 'number' ? this.transformToDate(item[key]) : item[key]) : '') : '';
    },

    transformArray(item, key) {
        return item ? (typeof item[key] !== 'undefined' ? (Array.isArray(item[key]) ? item[key] : []) : []) : [];
    },

    transformToDate(timestamp) {
        let date = new Date(timestamp * 1000);
        let day = date.getDay();
        let month = date.getMonth();
        let year = date.getFullYear();
        return (day < 10 ? '0' + day : day) + '/' + (month < 10 ? '0' + month : month) + '/' + year
    },
}
